import React from 'react';
import { formatDateDivider } from '../ticket.utils';
import styles from '../styles/ticket-thread.module.scss';

/**
 * @param {Object} props
 * @param {string} props.date
 */
function TicketDateDivider({ date }) {
    return (
        <div className={styles.dateDivider}>
            <span className={styles.dateDividerPill}>{formatDateDivider(date)}</span>
        </div>
    );
}

export default TicketDateDivider;
